import { BAND_CONFIG } from './config';
import type { BandFrameFeature } from './types';
import { clamp01, toBinIndex } from './utils';

export function buildBandFrameFeatures(powerSpectrum: Float32Array, sampleRate: number): BandFrameFeature[] {
  const maxValue = powerSpectrum.reduce((acc, value) => Math.max(acc, value), 0) || 1;
  return BAND_CONFIG.map((band) => {
    const startIdx = toBinIndex(band.hzMin, sampleRate, powerSpectrum.length);
    const endIdx = toBinIndex(band.hzMax, sampleRate, powerSpectrum.length);
    let sum = 0;
    let count = 0;
    for (let i = startIdx; i <= endIdx; i += 1) {
      sum += powerSpectrum[i];
      count += 1;
    }
    const energy = count ? clamp01((sum / count) / maxValue) : 0;
    return {
      ...band,
      energy
    };
  });
}
